<template>
  <div>
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-lg-6 logo-wrapper">
              <h1>Friday<br>Financial<br> Services</h1>
              <hr/>
              <p>Based in Lowestoft, Friday Financial Services are a team of professional mortgage
                brokers.<br>Assisting clients across the UK with their mortgage needs.</p>

              <router-link to="/contact-us/" class="btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row triangle">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
      <div class="yellow-background"></div>
      <!-- <div class="banner-image"></div> -->
    </div>

    <div class="about">
      <div class="container">
        <div class="row">
           <div class="col-lg-12">
              <div class="about-section">
                <div class="about-title">
                    <h2>
                      <strong class="gunsmoke">
                        About
                        <span>Us</span>
                      </strong>
                    </h2>
                    <hr class="about-underline"/>
                </div>
                <div id="about-inner">
                  <ul>
                      <li>Offering whole of market mortgage and protection advice</li>
                      <li>Access to highly experienced qualified mortgage brokers</li>
                      <li><a
                        href="https://www.google.com/search?q=friday+financial+services+&source=hp&ei=loS4YYGqHMGmaO6qvvAP&iflsig=ALs-wAMAAAAAYbiSpvjSRos7WZgrLGM9HNutAbleaig6&ved=0ahUKEwiBzYOpnOP0AhVBExoKHW6VD_4Q4dUDCAo&uact=5&oq=friday+financial+services+&gs_lcp=Cgdnd3Mtd2l6EAMyCwguEIAEEMcBEK8BOgsIABCABBCxAxCDAToOCC4QgAQQsQMQxwEQowI6DgguEIAEELEDEMcBENEDOgUILhCABDoICAAQgAQQsQM6CAguELEDEIMBOggIABCxAxCDAToOCC4QgAQQsQMQxwEQrwE6BQgAEIAEOggILhCABBCxAzoICAAQgAQQyQM6BggAEBYQHjoJCAAQyQMQFhAeUABY_R9g1yBoAHAAeACAAc0BiAHOIpIBBjAuMjkuMZgBAKABAQ&sclient=gws-wiz#lrd=0x47da1bf8b555ca21:0x947cf20227ed3bbe,1,,," target="_blank" class="orange-link">
                        Over 500 Google Reviews
                      </a></li>
                    </ul>

                  <img src="~@/assets/images/homepage-house.jpg" alt="house">
              </div>
            </div>
          </div>
      </div>
      </div>
      <div class="d-flex flex-column home-images">
        <div class="container">
          <div class="services-heading">
              <div id="services-title-container">
                  <h2>
                    <strong class="gunsmoke">
                      Our
                      <span>Services</span>
                    </strong>
                  </h2>
                  <hr class="about-underline"/>
              </div>
              <p>We offer a professional yet friendly experience, tailoring our service to suit the specific needs of the individual.</p>
          </div>
          <div class="services-card-outer d-flex flex-wrap">
            <div class="services-card d-flex flex-column align-items-center  p-0">
              <div class="services-image"></div>
              <div class="circle"><svg class="icon icon-home3"><use xlink:href="#icon-home3"></use></svg></div>
              <h3>First Time Buyer</h3>
            </div>
            <div class="services-card d-flex flex-column align-items-center  p-0">
              <div class="services-image"></div>
              <div class="circle"><svg id="icon-coin" class="icon icon-coin-pound"><use xlink:href="#icon-coin-pound"></use></svg></div>
              <h3>Remortgage</h3>
            </div>
            <div class="services-card d-flex flex-column align-items-center p-0">
              <div class="services-image"></div>
              <div class="circle"><svg class="icon icon-truck"><use xlink:href="#icon-truck"></use></svg></div>
              <h3>Home Mover</h3>
            </div>
            <div class="services-card d-flex flex-column align-items-center p-0">
              <div class="services-image"></div>
              <div class="circle"><svg class="icon icon-handshake-o"><use xlink:href="#icon-handshake-o"></use></svg></div>
              <h3>Buy To Let</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="testimonial-outer">
          <h2><strong>Testimonials</strong></h2>
          <hr/>
          <vue-slick-carousel class="slick" v-bind="settings">
            <div class="testimonial-container">
                <div class="quote-open">
                  <svg class="icon icon-quotes-left"><use xlink:href="#icon-quotes-left"></use></svg>
                </div>
                <div class="testimonial">
                    <p class="testimonial-body">
                      <span> <svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg></span>
                      Fantastic service from Wayne at Friday Financial. Not only did Wayne source our mortgage for us as first-time buyers but he thoroughly explained each process with us and even after his job was completed, he kept in contact with us checking in on our progress. In my opinion he went above and beyond with his service, and I would definitely use his services again and recommend his services to everyone.
                    </p>
                    <p class="testimonial-author">Adrienne - First time buyer </p>
                </div>
                <div class="quote-close">
                  <svg class="icon icon-quotes-right"><use xlink:href="#icon-quotes-right"></use></svg>
                </div>
            </div>
            <div class="testimonial-container">
                <div class="quote-open">
                  <svg class="icon icon-quotes-left"><use xlink:href="#icon-quotes-left"></use></svg>
                </div>
                <div class="testimonial">
                    <p class="testimonial-body">
                      <span> <svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg></span>
                      Friday Financial Services have assisted me twice, with a mortgage and then a remortgage. They have guided me through the minefield of Equity Transfer and the legal 'mumbo jumbo' associated with it all. I cannot thank Andrew and his team enough for their help... I think most of our communications has been via Email and WhatsApp (which is amazing for me, trying to do this whilst working full time)
                      Thank you, thank you thank you! 😊
                    </p>
                    <p class="testimonial-author">Tracey – Remortgage</p>
                </div>
                <div class="quote-close">
                  <svg class="icon icon-quotes-right"><use xlink:href="#icon-quotes-right"></use></svg>
                </div>
            </div>
            <div class="testimonial-container">
                <div class="quote-open">
                  <svg class="icon icon-quotes-left"><use xlink:href="#icon-quotes-left"></use></svg>
                </div>
                <div class="testimonial">
                    <p class="testimonial-body">
                      <span> <svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg></span>
                      Simply the best advice and service! Couldn't recommend this company enough. Any time, any question, no matter how big or small they're there to help and explain things. Andrew went above and beyond to help me, and my fiancé get a mortgage on our first house! The service doesn't stop there he also got us great life insurance as well as home and contents insurance.
                    </p>
                    <p class="testimonial-author">Harry – Life Insurance </p>
                </div>
                <div class="quote-close">
                  <svg class="icon icon-quotes-right"><use xlink:href="#icon-quotes-right"></use></svg>
                </div>
            </div>
            <div class="testimonial-container">
                <div class="quote-open">
                  <svg class="icon icon-quotes-left"><use xlink:href="#icon-quotes-left"></use></svg>
                </div>
                <div class="testimonial">
                    <p class="testimonial-body">
                      <span> <svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg><svg class="icon icon-star-full"><use xlink:href="#icon-star-full"></use></svg></span>
                      Lauren has been fantastic, she has made the whole finding a mortgage process so simple for us, guiding us through what we need to do and then taking all the usual application stress away for us. Lauren is always a call away and just great support at a stressful time. I would recommend Lauren and the team at Friday Financial Services for any future Mortgage applications or financial needs.
                    </p>
                    <p class="testimonial-author">Julia – House Purchase</p>
                 </div>
                 <div class="quote-close">
                    <svg class="icon icon-quotes-right"><use xlink:href="#icon-quotes-right"></use></svg>
                 </div>
            </div>
          </vue-slick-carousel>
        </div>
      </div>
      <div class="container">
          <div id="soro-blog"></div>
      </div>
    </div>

    <div class="cta">
      <div class="container">
        <div class="row d-flex align-items-center justify-content-between">
            <h2 class="mb-0 d-flex justify-content-center">
              <strong>Get In Touch</strong>
            </h2>
            <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Home',
  components: { VueSlickCarousel},
  data() {
      return {
        settings: {
        "dots": true,
        "autoplay": true,
        "autoplay-speed": 15000,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1
      }
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://app.trysoro.com/api/embed/42db13f8-9591-48ae-8a1d-2515f1513579'
    script.defer = true
    document.body.appendChild(script)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue